import bugsnag from "@bugsnag/js";
import classNames from "classnames";
import React, { FunctionComponent, ReactNode, useCallback, useRef, useState } from "react";
import iconUrl from "./upload.png";
import "./style.scss";

const SelectionUploadButton: FunctionComponent<{
  children: ReactNode;
  onFileChange: (files: File[]) => Promise<void>;
}> = ({ children, onFileChange }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [working, setWorking] = useState<boolean>(false);

  const onChange = useCallback(() => {
    const input = inputRef.current;
    if (!input || !input.files) {
      return;
    }

    setWorking(true);
    onFileChange(Array.from(input.files))
      .then(() => {
        setWorking(false);
      })
      .catch((e: Error) => {
        bugsnag.notify(e);
        // todo handle fileChange error
      });
  }, [onFileChange, setWorking]);

  const visibleButton = (
    <span
      className={classNames("SelectionUploadButton-content", {
        "SelectionUploadButton-content--disabled": working,
      })}
    >
      <span className="SelectionUploadButton-content-icon">
        <img alt="download" height="83" src={iconUrl} width="114" />
      </span>
      {children}
    </span>
  );

  return (
    <span className="SelectionUploadButton">
      {visibleButton}

      <input
        accept=".gif,.jpg,.jpeg,.png"
        className="SelectionUploadButton-input"
        disabled={working}
        multiple={true}
        onChange={onChange}
        ref={inputRef}
        type="file"
      />
    </span>
  );
};

export default SelectionUploadButton;
